var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hazard-overview"},[_c('custom-panel',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("隐患事件概况")]},proxy:true},{key:"default",fn:function(){return [(_vm.dataLoaded)?_c('dv-scroll-board',{attrs:{"config":_vm.config}}):_vm._e()]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }